// German for the lifecycle console. Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Write the qualification note here (at least 20 characters) — why this engagement is worth pursuing': 'Hier die Qualifizierungsnotiz schreiben (mindestens 20 Zeichen) — warum dieses Engagement verfolgt wird',
  // ── shared pieces (PhaseRail, GateLampBadge, marks) ──
  'Phase rail': 'Phasenleiste',
  'clear': 'erfüllt',
  'held — ticked by the operator': 'erfüllt — vom Operator abgehakt',
  'outstanding': 'offen',
  'not yet applicable': 'noch nicht anwendbar',
  'read from the record': 'aus dem Datensatz gelesen',
  'and': 'und',
  'and {n} more': 'und {n} weitere',

  // ── phases (crm.PHASE_LABELS) and commercial models (crm.COMMERCIAL_MODEL_LABELS) ──
  'Qualify': 'Qualifizierung',
  'Discovery': 'Discovery',
  'Design': 'Konzeption',
  'Contracting': 'Vertrag',
  'Mobilise': 'Mobilisierung',
  'Implement': 'Umsetzung',
  'Acceptance': 'Abnahme',
  'Handover': 'Übergabe',
  'Close (phase)': 'Abschluss',
  'Fixed price': 'Festpreis',
  'Time & materials': 'Nach Aufwand',
  'Capped T&M': 'Nach Aufwand mit Kostendach',
  'Retainer': 'Retainer',

  // ── a condition row ──
  'Untick this condition': 'Häkchen bei dieser Bedingung entfernen',
  'Tick this condition': 'Diese Bedingung abhaken',
  'automatic': 'automatisch',
  'automatic · the engine reads this, you cannot tick it': 'automatisch · die Engine liest das, Sie können es nicht abhaken',
  'The same subjects also sit under {list}{more}. {n} conditions, {refs}{moreRefs}, one piece of work.': 'Dieselben Gegenstände stehen auch unter {list}{more}. {n} Bedingungen, {refs}{moreRefs}, eine einzige Arbeit.',
  'and {n} other condition': 'und {n} weitere Bedingung',
  'and {n} other conditions': 'und {n} weitere Bedingungen',
  'manual · ticked': 'manuell · abgehakt',
  'manual · not yet ticked': 'manuell · noch nicht abgehakt',
  'why is this true? — recorded on the gate, quoted back in the record': 'warum trifft das zu? — am Gate festgehalten, im Protokoll zitiert',
  'saved': 'gespeichert',
  'manual · you are the source': 'manuell · Sie sind die Quelle',
  'Remove this custom condition': 'Diese eigene Bedingung entfernen',

  // ── a gate panel ──
  '{open} outstanding · {held} held': '{open} offen · {held} erfüllt',
  '{n} n/a': '{n} n. a.',
  '{n} skipped': '{n} übersprungen',
  'Reading {gate}…': '{gate} wird gelesen…',
  '{subject} — “{error}”. Nothing was written.': '{subject} — «{error}». Nichts wurde geschrieben.',
  '{gate} could not be evaluated': '{gate} konnte nicht ausgewertet werden',
  'Crossing {from} → {to} means clearing {n} gate, in order.': 'Der Übergang {from} → {to} bedeutet, {n} Gate zu passieren, der Reihe nach.',
  'Crossing {from} → {to} means clearing {n} gates, in order.': 'Der Übergang {from} → {to} bedeutet, {n} Gates zu passieren, der Reihe nach.',

  // ── toasts ──
  '{from} → {to} (forced)': '{from} → {to} (erzwungen)',
  '{from} → {to}': '{from} → {to}',
  'Condition added': 'Bedingung hinzugefügt',
  'Condition removed': 'Bedingung entfernt',
  'Name cannot be empty': 'Der Name darf nicht leer sein',
  'Review window must be a whole number of days between 0 and 365': 'Die Prüffrist muss eine ganze Zahl von Tagen zwischen 0 und 365 sein',
  'Engagement updated': 'Auftrag aktualisiert',
  'Engagement archived': 'Auftrag archiviert',
  'Engagement restored': 'Auftrag wiederhergestellt',

  // ── no engagement / loading / failed ──
  'Lifecycle': 'Lebenszyklus',
  'no engagement selected': 'kein Auftrag ausgewählt',
  'Lifecycle is a per-engagement surface': 'Der Lebenszyklus ist eine Fläche je Auftrag',
  'A phase, a gate and every checklist tick hang off one engagement — {a}, {b}. There is nothing to show until one is chosen.': 'Eine Phase, ein Gate und jedes Häkchen der Checkliste hängen an einem Auftrag — {a}, {b}. Es gibt nichts zu zeigen, bis einer gewählt ist.',
  '{n} of {total} outstanding': '{n} von {total} offen',
  'No engagement exists yet.': 'Es existiert noch kein Auftrag.',
  'The gate state in each label comes from {endpoint}.': 'Der Gate-Zustand in jeder Beschriftung stammt aus {endpoint}.',
  'Reading the gate…': 'Gate wird gelesen…',
  'the console could not be read': 'die Konsole konnte nicht gelesen werden',
  'The lifecycle console could not be loaded': 'Die Lebenszyklus-Konsole konnte nicht geladen werden',
  'The endpoint {endpoint} answered: “{error}”': 'Der Endpunkt {endpoint} antwortete: «{error}»',
  'no answer': 'keine Antwort',

  // ── masthead ──
  'sponsor {name}': 'Sponsor {name}',
  'not named': 'nicht benannt',
  'child of {code}': 'untergeordnet zu {code}',
  'The correspondence language — everything produced inside this engagement is written in it.': 'Die Korrespondenzsprache — alles, was in diesem Auftrag entsteht, wird in ihr geschrieben.',
  'estimate {value}': 'Schätzung {value}',
  'none': 'keine',
  'kickoff {date}': 'Kickoff {date}',
  'not set': 'nicht gesetzt',
  'review window {n} d': 'Prüffrist {n} T',
  'archived': 'archiviert',
  'Engagement record →': 'Auftragsdatensatz →',
  'name · sponsor · estimate · archive': 'Name · Sponsor · Schätzung · Archiv',

  // ── verdict ──
  'Verdict': 'Urteil',
  'not evaluated': 'nicht ausgewertet',
  'The gate engine did not answer, so {verdict}.': 'Die Gate-Engine hat nicht geantwortet, daher {verdict}.',
  'no verdict can be given': 'kann kein Urteil gefällt werden',
  'The phase is a column and is still true: {code} is in {phase}, step {step} of {count}. The conditions are queries and they failed — showing them as unmet would be a guess, and showing them as met would be a lie.': 'Die Phase ist eine Spalte und gilt weiterhin: {code} ist in {phase}, Schritt {step} von {count}. Die Bedingungen sind Abfragen, und sie sind fehlgeschlagen — sie als nicht erfüllt zu zeigen wäre geraten, sie als erfüllt zu zeigen wäre gelogen.',
  '{code} can leave {phase}. All {n} conditions on {gate} are held.': '{code} kann {phase} verlassen. Alle {n} Bedingungen auf {gate} sind erfüllt.',
  '{code} cannot leave {phase}: {open} of {total} conditions on {gate} are outstanding.': '{code} kann {phase} nicht verlassen: {open} von {total} Bedingungen auf {gate} sind offen.',
  '{n} you can tick here': '{n} können Sie hier abhaken',
  '{n} the engine reads elsewhere': '{n} liest die Engine anderswo',
  '. The {n} automatic subjects — {raw}{rawMore} — all come down to {roots}{rootsMore}.': '. Die {n} automatischen Gegenstände — {raw}{rawMore} — laufen alle auf {roots}{rootsMore} hinaus.',
  '. The automatic ones come down to {raw}{rawMore}.': '. Die automatischen laufen auf {raw}{rawMore} hinaus.',
  'Move to {phase}': 'Nach {phase} wechseln',
  'Gate {gate} is not clear': 'Gate {gate} ist nicht frei',
  'Advance to {phase}': 'Weiter nach {phase}',
  'Force past {gate}…': 'An {gate} vorbei erzwingen…',
  'lands in {phase}, guarded by {gate}': 'landet in {phase}, bewacht von {gate}',
  '{n} outstanding there': 'dort {n} offen',
  'the gate engine did not answer': 'die Gate-Engine hat nicht geantwortet',
  'tally unknown': 'Stand unbekannt',
  'Final phase — no gate ahead.': 'Letzte Phase — kein Gate voraus.',
  'Re-evaluate the gate': 'Gate neu auswerten',
  'Step back…': 'Zurückgehen…',

  // ── approach vector ──
  'Approach vector': 'Vorgehensleiste',
  '{n} condition skipped at a forced crossing, still unmet': '{n} Bedingung bei einem erzwungenen Übergang übersprungen, weiterhin nicht erfüllt',
  '{n} conditions skipped at a forced crossing, still unmet': '{n} Bedingungen bei einem erzwungenen Übergang übersprungen, weiterhin nicht erfüllt',
  'click to inspect': 'zum Prüfen klicken',
  'Step {step} of {count}': 'Schritt {step} von {count}',
  '{n} forced crossing on the record': '{n} erzwungener Übergang im Protokoll',
  '{n} forced crossings on the record': '{n} erzwungene Übergänge im Protokoll',
  '{n} transition': '{n} Übergang',
  '{n} transitions': '{n} Übergänge',
  'since {date}': 'seit {date}',
  'recorded': 'erfasst',

  // ── the gate ──
  '— not evaluated': '— nicht ausgewertet',
  '{n} not yet applicable': '{n} noch nicht anwendbar',
  '{n} condition, no values': '{n} Bedingung, keine Werte',
  '{n} conditions, no values': '{n} Bedingungen, keine Werte',
  'The labels are code-level constants and are shown because they are real. Their values come from {source}, which answered: “{message}”. Nothing was written. Forcing still works — it records a reason, not a gate reading.': 'Die Beschriftungen sind Konstanten im Code und werden gezeigt, weil sie real sind. Ihre Werte stammen aus {source}, das antwortete: «{message}». Nichts wurde geschrieben. Erzwingen funktioniert weiterhin — es hält eine Begründung fest, keine Gate-Auswertung.',
  'value unknown': 'Wert unbekannt',
  'manual': 'manuell',
  'Retry': 'Erneut versuchen',
  'Outstanding': 'Offen',
  'what stands between {code} and {phase}': 'was zwischen {code} und {phase} steht',
  'closure': 'dem Abschluss',
  'nothing': 'nichts',
  'Nothing outstanding.': 'Nichts offen.',
  'Every condition on {gate} is held. The advance control above is live.': 'Jede Bedingung auf {gate} ist erfüllt. Die Schaltfläche zum Weitergehen oben ist aktiv.',
  'Held‖conditions': 'Erfüllt',
  'collapse': 'einklappen',
  'show the {n} condition already held': 'die {n} bereits erfüllte Bedingung zeigen',
  'show the {n} conditions already held': 'die {n} bereits erfüllten Bedingungen zeigen',
  'nothing on this gate is held yet': 'auf diesem Gate ist noch nichts erfüllt',
  'Add a condition to {gate}…': 'Bedingung zu {gate} hinzufügen…',
  'Add': 'Hinzufügen',
  'standard conditions cannot be removed — untick them': 'Standardbedingungen können nicht entfernt werden — Häkchen entfernen',

  // ── ahead / behind ──
  'What is ahead': 'Was voraus liegt',
  'read-only · nothing here can be ticked yet': 'nur lesend · hier kann noch nichts abgehakt werden',
  '{n} conditions ahead read as satisfied only because nothing has been recorded against them yet (no defect, no change request, no acceptance record). They are shown as {dash}, not as held, so a far gate cannot look nearer than a near one.': '{n} Bedingungen voraus gelten nur deshalb als erfüllt, weil noch nichts gegen sie erfasst wurde (kein Mangel, kein Änderungsantrag, kein Abnahmeprotokoll). Sie werden als {dash} gezeigt, nicht als erfüllt, damit ein fernes Gate nicht näher wirkt als ein nahes.',
  'What is behind': 'Was zurückliegt',
  'show the {n} gate already crossed': 'das {n} bereits passierte Gate zeigen',
  'show the {n} gates already crossed': 'die {n} bereits passierten Gates zeigen',
  '{n} skipped at a forced crossing, still unmet': '{n} bei einem erzwungenen Übergang übersprungen, weiterhin nicht erfüllt',
  'nothing left owing': 'nichts mehr ausstehend',

  // ── the record ──
  'The record': 'Das Protokoll',
  '{n} transition · append-only': '{n} Übergang · nur anfügend',
  '{n} transitions · append-only': '{n} Übergänge · nur anfügend',
  'forced': 'erzwungen',
  'back': 'zurück',
  '{gate} stood at {tally}': '{gate} stand bei {tally}',
  '{met} of {total}': '{met} von {total}',
  'clear at the time': 'damals frei',
  '{n} unmet at the time': 'damals {n} nicht erfüllt',
  '{still} of the {total} condition skipped on {gate} at this crossing is still unmet: {list}.': '{still} von der {total} bei diesem Übergang auf {gate} übersprungenen Bedingung ist weiterhin nicht erfüllt: {list}.',
  '{still} of the {total} conditions skipped on {gate} at this crossing is still unmet: {list}.': '{still} der {total} bei diesem Übergang auf {gate} übersprungenen Bedingungen ist weiterhin nicht erfüllt: {list}.',
  '{still} of the {total} conditions skipped on {gate} at this crossing are still unmet: {list}.': '{still} der {total} bei diesem Übergang auf {gate} übersprungenen Bedingungen sind weiterhin nicht erfüllt: {list}.',
  'system': 'System',
  'No transition has been recorded': 'Kein Übergang verzeichnet',
  'The engagement has not left its opening phase. A row lands in {table} the moment it does.': 'Der Auftrag hat seine Anfangsphase nicht verlassen. Sobald er es tut, landet eine Zeile in {table}.',
  'Document classification, uploads, portal previews and proposal decisions are {not} here — they are the audit log, and they live on {link}. This section carries only what moved the engagement. Every figure above comes from {source}.': 'Dokumentklassifizierung, Uploads, Portal-Vorschauen und Entscheidungen zu Vorschlägen sind {not} hier — sie sind der Prüfpfad und liegen unter {link}. Dieser Abschnitt führt nur, was den Auftrag bewegt hat. Jede Zahl oben stammt aus {source}.',
  'not': 'nicht',
  'Admin · audit': 'Admin · Prüfpfad',

  // ── step back ──
  'Step back': 'Zurückgehen',
  'Backward moves are always permitted and always recorded — a backward move crosses no gate. Pick where {code} goes.': 'Rückwärtsbewegungen sind immer erlaubt und werden immer verzeichnet — eine Rückwärtsbewegung passiert kein Gate. Wählen Sie, wohin {code} geht.',
  'Move back to {phase} →': 'Zurück nach {phase} →',
  'guarded by {gate} on the way out again': 'auf dem Weg hinaus erneut von {gate} bewacht',
  'Cancel': 'Abbrechen',

  // ── force override ──
  'Force past {gate}': 'An {gate} vorbei erzwingen',
  'Override on the permanent record': 'Übersteuerung im dauerhaften Protokoll',
  'Moving {code} from {from} to {to} with {n} condition unmet. The reason below is written to the phase transition, snapshot-stamped with the gate state, and read back in the record forever.': '{code} wird von {from} nach {to} bewegt, mit {n} nicht erfüllten Bedingung. Die Begründung unten wird in den Phasenübergang geschrieben, mit dem Gate-Zustand gestempelt und für immer im Protokoll wiedergegeben.',
  'Moving {code} from {from} to {to} with {n} conditions unmet. The reason below is written to the phase transition, snapshot-stamped with the gate state, and read back in the record forever.': '{code} wird von {from} nach {to} bewegt, mit {n} nicht erfüllten Bedingungen. Die Begründung unten wird in den Phasenübergang geschrieben, mit dem Gate-Zustand gestempelt und für immer im Protokoll wiedergegeben.',
  'What the snapshot will say is unmet': 'Was der Schnappschuss als nicht erfüllt ausweisen wird',
  'manual · not ticked': 'manuell · nicht abgehakt',
  'These become the engagement’s debt: the record will show them as skipped, and this page will keep saying so until they are met.': 'Diese werden zur Schuld des Auftrags: Das Protokoll zeigt sie als übersprungen, und diese Seite sagt das weiter, bis sie erfüllt sind.',
  'Override reason': 'Begründung der Übersteuerung',
  '— your words, quoted back verbatim': '— Ihre Worte, wörtlich zitiert',
  'Why is this move justified despite the gate?': 'Warum ist dieser Schritt trotz des Gates gerechtfertigt?',
  'I accept that this override is permanent and visible in the engagement record.': 'Ich akzeptiere, dass diese Übersteuerung dauerhaft und im Auftragsprotokoll sichtbar ist.',
  'Force to {phase}': 'Nach {phase} erzwingen',

  // ── the engagement record ──
  'Engagement record — {code}': 'Auftragsdatensatz — {code}',
  'Name': 'Name',
  'Commercial model': 'Kommerzielles Modell',
  'Currency': 'Währung',
  'Inherited from the client; everything produced inside this engagement is written in it.': 'Vom Kunden übernommen; alles, was in diesem Auftrag entsteht, wird in ihr geschrieben.',
  'Language': 'Sprache',
  'Review window (d)': 'Prüffrist (T)',
  'Sponsor': 'Sponsor',
  'not named yet': 'noch nicht benannt',
  'no contacts on this client': 'keine Kontakte bei diesem Kunden',
  'Signs the SOW and acceptance records; clears the counterpart condition on {gate}.': 'Unterzeichnet SOW und Abnahmeprotokolle; erfüllt die entsprechende Bedingung auf {gate}.',
  'Estimate ({currency})': 'Schätzung ({currency})',
  'Satisfies {gate} until milestones are priced.': 'Erfüllt {gate}, bis Meilensteine bepreist sind.',
  'Kickoff date': 'Kickoff-Datum',
  'Parent engagement': 'Übergeordneter Auftrag',
  'The code {code} is immutable — it is baked into refs and the agent workspace. Gate {gate} reads the kickoff date; the review window drives deemed-acceptance timers on every acceptance record issued from now on.': 'Der Code {code} ist unveränderlich — er steckt in Refs und im Arbeitsbereich des Agenten. Gate {gate} liest das Kickoff-Datum; die Prüffrist steuert die Fristen der stillschweigenden Abnahme auf jedem ab jetzt ausgestellten Abnahmeprotokoll.',
  'Restore': 'Wiederherstellen',
  'Archive': 'Archivieren',
  'Saving…': 'Wird gespeichert…',
  'Save': 'Speichern',

  // ── confirm dialogs ──
  'Archive engagement': 'Auftrag archivieren',
  'Archive {code}? Nothing is deleted — the engagement drops out of the active list and its portal, register and history stay exactly as they are. You can restore it from this dialog.': '{code} archivieren? Nichts wird gelöscht — der Auftrag fällt aus der aktiven Liste, und Portal, Register und Historie bleiben genau, wie sie sind. Sie können ihn aus diesem Dialog wiederherstellen.',
  'Remove gate condition': 'Gate-Bedingung entfernen',
  'Remove': 'Entfernen',
  'Remove the custom condition “{label}” from gate {gate}? Standard conditions cannot be removed — untick them instead.': 'Die eigene Bedingung «{label}» von Gate {gate} entfernen? Standardbedingungen können nicht entfernt werden — entfernen Sie stattdessen das Häkchen.',
}, 'EngagementPage');
